import PageHeader from "../../components/common/PageHeader";
import VariantUnitsSection from "../Setting/components/VariantUnitsSection";

/**
 * Variant Units Master page
 * Manage the "Unit" options shown when adding product variants
 * (e.g. Single, Quarter, Half, Full) - reachable from the Settings hub.
 */
const VariantUnits = () => {
  return (
    <div className="space-y-6 pb-8">
      <PageHeader
        title="Variant Units"
        subtitle="Manage the unit options available when adding product variants"
      />
      <VariantUnitsSection />
    </div>
  );
};

export default VariantUnits;
